import React from 'react';

const MenuSpacer = () => <div className="menu-spacer" />;

export default MenuSpacer;
